import beforePage from './before-page'
import qrcodeImg from '../assets/home/qrcode-full.png'
import { request, createAndClickAnchor, formatEmailDisplay,isModelKey,isInDashboard,checkAccountActive,checkCustomerAccess, getUserColor, getUserName } from './utils'
import { STORAGE_KEY } from './consts'
import './log-envent.js'
import { initLogs, initRum, setUser } from './datalog'
import i18n, { updatePageLanguage } from '../lang/index.js'
import Cookies from 'js-cookie'
import Toast from './toast.js'
import { initUserStore, userStore, initCustomerStore } from '../admin/store/bridge.js'
import { getActivePinia } from 'pinia'
import { useUploadStore } from '../models/stores/upload/useUploadStore.js'
import initRequestConfig from './requestConfig'
const t = i18n.global.t

window.isScanatLoaded = false

initRequestConfig();

const initClickHandler = () => {
  let clickTimer = null
  const clickDelay = 300

  document.addEventListener('click', (e) => {
    if (e.button !== 0) return

    if (clickTimer) {
      return
    };

    clickTimer = setTimeout(() => {
      clickTimer = null
      }, clickDelay)

    }, true)

    document.addEventListener('dblclick', (e) => {
      clearTimeout(clickTimer)
      clickTimer = null
    }, true)
}

// 引入iconfont 
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = '//at.alicdn.com/t/c/font_4900802_fpa1z8trh4a.css';
document.head.appendChild(link);

const handleDomContentLoad = async () => {
  // initClickHandler()
  // if(document.documentElement.lang) {
  //   updatePageLanguage()
  //   const observer = new MutationObserver((mutationsList) => {
  //     mutationsList.forEach(mutation => {
  //       if (mutation.type === 'attributes') {
  //         Array.from(mutation.target.attributes).forEach(attr => {
  //           if (attr.value.startsWith('$lang(') && attr.name === mutation.attributeName) {
  //             updatePageLanguage()
  //             throw new Error('break loop')
  //           }
  //         })
  //       }
  //     })
  //   })
  //   observer.observe(document.documentElement, {
  //     attributes: true,
  //     subtree: true,
  //     attributeOldValue: true,
  //   })
  // }
  let customerRes = null
  try {
   customerRes = (await request('portal/customers', null, true, 'GET'))?.data ?? null 
   sessionStorage.setItem('customer', JSON.stringify(customerRes))
   initCustomerStore(customerRes)
  } catch (error) {
    console.error(error?.message)
  }
 
  window.isScanatLoaded = true
  // We need get user info first
  let res = { data: null }
  let userInfo = {}
  const isNoAuthPage =
    location.pathname.includes('login.html') ||
    location.pathname.includes('intage.html') ||
    location.search.includes('&intage')

  // do not need to get user info on login page
  if (!isNoAuthPage) {
    
      const authRes = await request('auth/currentUserInfo', null, true, 'POST', true)
      if (authRes?.status === 200) {
      res = await authRes.json()
      userInfo = res.data
      initUserStore(res.data)
      setUser({
        id: res.data.userId,
        email: res.data.email
      })
      } else {
        document.querySelector('.login-area')?.classList.remove('d-none')
        document.querySelector('.avatar-area')?.classList.add('d-none')
        sessionStorage.removeItem('SCANAT_USER_INFO')
      }
  }

  // set avatar
  const customerNameEl = document.querySelector('.customer-name')
  const customerIdEl = document.querySelector('.customer-id')
  const updateCustomerName = () => {
    if (customerNameEl && customerIdEl) {
      const loginArea = document.querySelector('.login-area')
      try {
        const avatarArea = document.querySelector('.avatar-area')
        const userInfo = JSON.parse(sessionStorage.getItem('SCANAT_USER_INFO') || '{}')
        if (userInfo?.surname && userInfo?.name) {
          customerNameEl.textContent = `${userInfo.surname} ${userInfo.name}`
          const avatarEl = document.querySelector('#navbarDropdownMenuAvatar img')
          if (avatarEl && avatarEl.parentNode) {
            const circleEl = document.createElement('div')
            circleEl.className = 'user-circle'
            circleEl.style.background = getUserColor(userInfo)
            circleEl.innerHTML = `<span>${getUserName(userInfo)}</span>`
            avatarEl.parentNode.replaceChild(circleEl, avatarEl)
          }
        } else {
          const currentLang = localStorage.getItem('SCANAT_LANG') || Cookies.get('language') || 'ja'
          i18n.global.locale.value = currentLang
          customerNameEl.textContent = i18n.global.t('landing.unnamed')
        }
        customerIdEl.textContent = formatEmailDisplay(userInfo.email || '')
      } catch (error) {
        console.error('error on update customer name', error)
      }
    }
  }
  
  if (customerNameEl && customerIdEl) {
    const loginArea = document.querySelector('.login-area')

    try {
      const avatarArea = document.querySelector('.avatar-area')
      if (res?.code === 200) {
        // save user info
        sessionStorage.setItem('SCANAT_USER_INFO', JSON.stringify(res.data))
        if (res.data?.surname && res.data?.name) {
          customerNameEl.textContent = `${res.data.surname} ${res.data.name}`
          const avatarEl = document.querySelector('#navbarDropdownMenuAvatar img')
          if (avatarEl && avatarEl.parentNode) {
            const circleEl = document.createElement('div')
            circleEl.className = 'user-circle'
            circleEl.style.background = getUserColor(userInfo)
            circleEl.innerHTML = `<span>${getUserName(userInfo)}</span>`
            avatarEl.parentNode.replaceChild(circleEl, avatarEl)
          }
        } else {
          customerNameEl.textContent = t('landing.unnamed')
        }

        customerIdEl.textContent = formatEmailDisplay(res.data.email)
        avatarArea?.classList.remove('d-none')
        loginArea?.classList.add('d-none')

        console.log('set avatar')
      }
    } catch (error) {
      console.error('error on set avatar', error)
    }
    
    window.addEventListener('languageChanged', () => {
      updateCustomerName()
    })
  }

  const navWebEl = document.querySelector('.navbar-web')
  const navDashboardEl = document.querySelector('.navbar-dashboard')
  if (navWebEl) {
    navWebEl.onclick = async () => {
      const accessResult = await checkCustomerAccess();  
      console.log(accessResult, 'accessResult')
      if (!accessResult.canAccess) {
        if(typeof accessResult.callback === 'function') {
          accessResult.callback()
          return
        }
        new Toast().toast('warning', accessResult.message, false, {
          closeable: accessResult.closeable,
          autohide: !accessResult.closeable,
        });
        return;
      }
      window.location.href = '/models.html'
    }
  }

  if (navDashboardEl) {
    navDashboardEl.onclick = async () => {     
      const { isNoPortalAdmin} = await checkAccountActive()
        if(customerRes?.customerId && isNoPortalAdmin)  {
          new Toast().toast('warning', t('error.contactManage'))
          return
        }
      window.location.href = '/admin.html'
    }
  }
 
  if (location.pathname.includes('models.html')) {
    const main = document.querySelector('main')
   
    const checkModelsPagePermission = async () => {
      const pinia = getActivePinia()
      if (pinia && useUploadStore(pinia).isUploading) return
      const accessResult = await checkCustomerAccess();  
      if (!accessResult.canAccess && !isModelKey()) {
        main.classList.add('d-none')
        if(typeof accessResult.callback === 'function') {
          accessResult.callback()
          return
        }     
        new Toast().toast('warning', accessResult.message, false, {
          closeable: accessResult.closeable,
          autohide: !accessResult.closeable,
          above: true,
          callback: () => {
            window.location.href = '/landing.html'
          }
        });
      }else {
        main.classList.remove('d-none')
      }
    }
    main.addEventListener('click', checkModelsPagePermission, true)
    const iframe = document.querySelector('.model-frame')
    if (iframe) {
      iframe.onload = function() {
        iframe.contentWindow.document.addEventListener('click', checkModelsPagePermission, true)
      }
    }
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach((node) => {
                  if (node.tagName === 'IFRAME' && node.classList.contains('model-frame')) {
                      node.onload = function() {
                        node.contentWindow.document.addEventListener('click', checkModelsPagePermission, true)
                      }
                  }
              })
          }
      }
    })

    observer.observe(main, { childList: true, subtree: true })
    checkModelsPagePermission()
      if (navWebEl) {
        navWebEl.classList.add('active')
        navWebEl.onclick = () => {}
      }
  }

  //  logout
  const logoutBtn = document.querySelector('.btn-logout')
  logoutBtn?.addEventListener('click', e => {
    e.preventDefault()
    localStorage.removeItem('SCANAT_TOKEN')
    localStorage.removeItem('SCANAT_REFRESH_TOKEN')
    sessionStorage.removeItem('SCANAT_USER_INFO')
    localStorage.removeItem(STORAGE_KEY.LOGIN_TIME)
    sessionStorage.removeItem('SCANAT_SHARE_KEY')
    sessionStorage.removeItem('customer')
    if (userStore) {
      userStore.clearUserData()
    }
    window.location.href = '/login.html'
  })

  const key = isModelKey()
  if (key) {
    if (!location.pathname.includes('models.html')) {
      location.href = `/models.html?${key}`
      console.log('redirect to models')
    }
    return
  }
  const dashboardBody = document.querySelector('.dashboard-body')
  const msg =
    'この機能はまだ利用できませんが、現在リリースの準備をしており、少しお待たせしてしまうことになります。'

  if (location.pathname.includes('landing.html')) {
    const iconDashboardEl = document.querySelector('.landing-dashboard')
    if (iconDashboardEl) {
      iconDashboardEl.onclick = async () => {
       const { isNoPortalAdmin} = await checkAccountActive()
        if(customerRes?.customerId && isNoPortalAdmin)  {
          new Toast().toast('warning', t('error.contactManage'))
          return
        }
        
        createAndClickAnchor('/admin.html', '_blank')
      }
    }

    const icon = document.querySelector('.landing-models')
   
    if (icon) {
        icon.onclick = async () => {
          const accessResult = await checkCustomerAccess();
          console.log(accessResult, 'accessResult')
          if (!accessResult.canAccess) {
            if(typeof accessResult.callback === 'function') {
              accessResult.callback() 
              return
            }
            new Toast().toast('warning', accessResult.message, false, {
              closeable: accessResult.closeable,
              autohide: !accessResult.closeable,
            });
            
            return;
          }
     
          createAndClickAnchor('/models.html', '_blank')
        }
      }
    

    dashboardBody?.classList.remove('d-none')
  }

  if (isInDashboard) {
    const main = document.body.querySelector('main')
    const eventsToWatch = ['click'];
    const checkDashboardPermission = async (e) => {
      const { isNoPortalAdmin } = await checkAccountActive()
      if (customerRes?.customerId && isNoPortalAdmin) {
        e?.preventDefault();
        e?.stopPropagation();
        main.classList.add('d-none')
        document.body.innerHTML = ''
        const msg = t('error.contactManage')
        new Toast().toast('warning', msg, false, {
          above: true,
          callback: () => {
              window.location.href = '/landing.html'
          }
        }) 
        return
      }else {
        main.classList.remove('d-none')
      }
    }
   
    eventsToWatch.forEach((eventName) => {
          main.addEventListener(eventName, checkDashboardPermission, true);
        });
    
    checkDashboardPermission()
  }

  if (!isNoAuthPage && isInDashboard) {
    // works for dashboard or other pages
    if (customerRes?.myDeptType === 2) {
      const sidebar = document.querySelector('#sidebarMenu')
      const ordersEl = sidebar?.querySelector('.sidebar-orders')
      const devicesEl = sidebar?.querySelector('.sidebar-devices')
      
      ordersEl?.classList.add('d-none')
      devicesEl?.classList.add('d-none')
    }
    dashboardBody?.classList.remove('d-none')
  }

  await beforePage()

  if (location.pathname.includes('rules.html')) {
    window.location.href = '/assets/files/rules.pdf'
    return
  }

  const sidebar = document.querySelector('#sidebarMenu')
  
  // sidebar
  if (location.hash.includes('logs')) {
    const order = sidebar?.querySelector('.sidebar-logs')
    order?.classList.add('sidebar-active')

    if (navDashboardEl) {
      navDashboardEl.classList.add('active')
      navDashboardEl.onclick = () => {}
    }
  }

  if (location.hash.includes('dashboard')) {
    const order = sidebar?.querySelector('.sidebar-dashboard')
    order?.classList.add('sidebar-active')

    if (navDashboardEl) {
      navDashboardEl.classList.add('active')
      navDashboardEl.onclick = () => {}
    }
  }

  if (location.hash.includes('enterprise')) {
    const order = sidebar?.querySelector('.sidebar-enterprise')
    order?.classList.add('sidebar-active')

    if (navDashboardEl) {
      navDashboardEl.classList.add('active')
      navDashboardEl.onclick = () => {}
    }
  }

  if (location.hash.includes('orders') || location.hash.includes('payment')) {
    const order = sidebar?.querySelector('.sidebar-orders')
    order?.classList.add('sidebar-active')
    if (navDashboardEl) {
      navDashboardEl.classList.add('active')
      navDashboardEl.onclick = () => {}
    }
  }

  if (location.hash.includes('devices')) {
    const order = sidebar?.querySelector('.sidebar-devices')
    order?.classList.add('sidebar-active')

    if (navDashboardEl) {
      navDashboardEl.classList.add('active')
      navDashboardEl.onclick = () => {}
    }
  }

  // invitation
  if (location.hash.includes('invitation')) {
    const order = sidebar?.querySelector('.sidebar-invitation')
    order?.classList.add('sidebar-active')

    if (navDashboardEl) {
      navDashboardEl.classList.add('active')
      navDashboardEl.onclick = () => {}
    }
  }

  // navbar
  const navbar = document.querySelector('.navbar-nav')
  let currentActiveClass
  switch (true) {
    case location.pathname.includes('fee-plans.html'):
      currentActiveClass = '.nav-fee'
      break
    case location.pathname.includes('introduction.html'):
      currentActiveClass = '.nav-intro'
      break
    case location.pathname.includes('show-case.html'):
      currentActiveClass = '.nav-case'
      break
    case location.pathname.includes('content-tab-5.html'):
    case location.pathname.includes('/articles/'):
    case location.pathname.includes('news.html'):
      currentActiveClass = '.nav-news'
      break
    default:
      currentActiveClass = '.nav-home'
      break
  }
  const currentActiveNav = navbar?.querySelector(currentActiveClass)
  currentActiveNav?.classList.add('active')

  // tooltip
  const downloadEl = document.querySelector('.download')
  if (downloadEl) {
    const tooltip = new mdb.Tooltip(downloadEl)
    tooltip._config.title = 'このアプリはiOSのみ対応しております。'
    tooltip._config.placement = 'bottom'
    tooltip._config.customClass = 'tooltip-download'
  }

  const qrCodeEl = document.querySelector('.qrcode')
  if (qrCodeEl) {
    new mdb.Tooltip(qrCodeEl, {
      title: 'qr code',
      html: true,
      placement: 'right',
      customClass: 'tooltip-qrcode',
      trigger: 'hover',
      template: `<div class="tooltip-qrcode" role="tooltip"><img src=${qrcodeImg} alt='qrcode'  /></div>`,
      container: qrCodeEl
    })
  }

  const urlToken = location.search.split('?token=')?.[1]
  if (urlToken) {
    localStorage.setItem('SCANAT_TOKEN', urlToken)
  }
}

if (['interactive', 'complete'].includes(document.readyState) && !window.isScanatLoaded) {
  handleDomContentLoad()
  document.removeEventListener('DOMContentLoaded', handleDomContentLoad)
} else {
  document.addEventListener('DOMContentLoaded', handleDomContentLoad)
}

if (!window.isDataLog) {
  window.isDataLog = true
  initLogs()
  initRum()
}